import React from 'react';

import { appMethod as app } from '@utils/app';
import { transformPx2Rem, convertStyleData } from '@utils/tools';

import { RequestStatus } from 'src/common/request-status/RequestStatus';

import './CommunityCustomComponent.less';

/**
 * type: "community" 
 * 组件：社区组件
 */

export default class CommunityCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let newData = {};
    if (customFeature.mode == undefined) {
      newData['eles[' + compindex + '].customFeature.mode'] = 0;
      newData['eles[' + compindex + '].customFeature.style'] = 1;
    }
    pageInstance.setData(newData);

    this.initialCommunityList(compindex, pageInstance);
  }

  initialCommunityList = (compindex, pageIns) => {
    let pageInstance = pageIns || app.getAppCurrentPage();
    let compdata = pageInstance.data.eles[compindex];
    let dataId = [];
    let content = compdata.content;
    let newdata = {};

    for (let j in content) {
      dataId.push(content[j]['community-id']);
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetSectionByPage',
      data: {
        section_ids: dataId,
        page: 1,
        page_size: 100
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let ddata = {},
          lastdata = [],
          newdata = {};

        for (let x = 0; x < res.data.length; x++) {
          let val = res.data[x];
          ddata[val.id] = val;
        }
        for (let y = 0; y < dataId.length; y++) {
          let val = ddata[dataId[y]];
          if (val) {
            lastdata.push(val);
          }
        }
        newdata['eles[' + compindex + '].community_data'] = lastdata;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function(){
        let newdata = {};
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = true;
        pageInstance.setData(newdata);
      }
    });
  }

  // 跳转社区页
  turnToCommunityPage = (event) => {
    let id = event.currentTarget.dataset.id;
    let franchisee = app.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    app.turnToPage('communityPage?detail=' + id + chainParam);
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 组件样式
    const styleObj = convertStyleData(data.style);
    const itemStyle = {
      height: transformPx2Rem(customFeature.lineHeight, 320),
      marginBottom: transformPx2Rem(customFeature.margin, 320),
      backgroundColor: customFeature.lineBackgroundColor,
      backgroundImage: customFeature.lineBackgroundImage,
    }
    if (customFeature.mode != 0) {
      itemStyle['width'] = transformPx2Rem(customFeature.imgWidth, 320);
    }
    if (customFeature.mode == 2) {
      itemStyle['marginRight'] = transformPx2Rem(customFeature.maskMarginSpace, 320);
    }
    const imgStyle = {
      width: transformPx2Rem(customFeature.imgWidth, 320),
      height: transformPx2Rem(customFeature.imgHeight, 320),
    }
    const descStyle = {
      color: customFeature.secColor,
      fontSize: transformPx2Rem(customFeature.secFontSize, 375),
      fontStyle: customFeature.secFontStyle,
      fontWeight: customFeature.secFontWeight ? customFeature.secFontWeight : 'normal',
      textAlign: customFeature.secTextAlign,
      textDecoration: customFeature.secTextDecoration,
    }
    const maskStyle = {
      backgroundColor: customFeature.maskBackgroundColor,
      opacity: customFeature.opacity,
    }

    return (
      <div className={`custom-component community mode-${customFeature.mode} style-${customFeature.style}`} style={styleObj}>
        {/* 社区样式展示 */}
        {customFeature.mode == 0 && data.community_data && data.community_data.map((item, index) => 
            <div className="item" key={index} style={itemStyle} onClick={this.turnToCommunityPage} data-id={item.id}>
              <div className="content">
                <img className="img" style={imgStyle} src={item.img} alt=""/>
                <div className="container">
                  <div className="info">
                    <div className="title">{item.name}</div>
                    {
                      item.show_article_comment &&
                      <div className="num" style={descStyle}>话题 {item.xcx_article_count}</div>
                    }
                  </div>
                  <div className="desc" style={descStyle}>{item.description}</div>
                </div>
              </div>
            </div>
          )
        }
        {(customFeature.mode == 1 || customFeature.mode == 2) && data.community_data && data.community_data.map((item, index) => 
            <div className="item" key={index} style={itemStyle} onClick={this.turnToCommunityPage} data-id={item.id}>
              <div className="img-container">
                <img className="img" style={imgStyle} src={item.img} alt=""/>
                {
                  customFeature.style == 0 &&
                  <div className="mask" style={maskStyle}></div>
                }
              </div>
              <div className="info">
                <div className="title">{item.name}</div>
                {
                  item.show_article_comment &&
                  <div className="num" style={descStyle}>{item.xcx_article_count}话题</div>
                }
              </div>
            </div>
          )
        }
        {/* 加载loading */}
        {
          data.loading && 
          <RequestStatus is="requestLoading"></RequestStatus>
        }
        {/* 加载失败 */}
        {
          data.loadingFail &&
          <RequestStatus is="requestFail" data={{refreshEvent: 'getCommunityList', compindex: this.props.index}}></RequestStatus>
        }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/community-custom-component/CommunityCustomComponent.jsx